import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f668eb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gradient-to-br from-primary-700 to-primary-800 p-8 text-white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-12 bg-accent-500 rounded-xl flex items-center justify-center" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "w-7 h-7",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-heading font-bold" }, " Welcome to Foxwood Crossing! "),
      /*#__PURE__*/_createElementVNode("p", { class: "text-primary-200 text-sm" }, " Your neighborhood, connected ")
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary-600 mb-6" }, " We've refreshed your community portal with new features to help neighbors connect and collaborate. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 mb-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-start gap-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-accent-100 rounded-lg flex items-center justify-center flex-shrink-0" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "w-4 h-4 text-accent-600",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800" }, " Community Proposals "),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary-500" }, " Suggest improvements and gather support from neighbors ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-start gap-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "w-4 h-4 text-blue-600",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800" }, " Events Calendar "),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary-500" }, " Stay up to date with neighborhood gatherings and meetings ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-start gap-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "w-4 h-4 text-green-600",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800" }, "Neighbor Posts"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-primary-500" }, " Share updates, ask questions, and connect with the community ")
    ])
  ])
], -1))

import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["close", "get-started"],
  setup(__props, { expose, emit }) {

const STORAGE_KEY = "foxwood_welcome_seen";

const isOpen = ref(false);



onMounted(() => {
  const hasSeenWelcome = localStorage.getItem(STORAGE_KEY);
  if (!hasSeenWelcome) {
    // Small delay for better UX
    setTimeout(() => {
      isOpen.value = true;
    }, 500);
  }
});

const markAsSeen = () => {
  localStorage.setItem(STORAGE_KEY, "true");
};

const handleClose = () => {
  markAsSeen();
  isOpen.value = false;
  emit("close");
};

const handleGetStarted = () => {
  markAsSeen();
  isOpen.value = false;
  emit("get-started");
};

// Expose method to show modal again (for testing or "What's New" link)
expose({
  show: () => {
    isOpen.value = true;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-primary-900/70 backdrop-blur-sm",
                onClick: handleClose
              }),
              _createElementVNode("div", { class: "relative bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" }, [
                _hoisted_2,
                _createElementVNode("div", { class: "p-6" }, [
                  _hoisted_3,
                  _hoisted_4,
                  _createElementVNode("div", { class: "flex flex-col sm:flex-row gap-3" }, [
                    _createElementVNode("button", {
                      onClick: handleGetStarted,
                      class: "flex-1 px-6 py-3 bg-accent-600 text-white font-medium rounded-xl hover:bg-accent-700 transition-colors"
                    }, " Get Started "),
                    _createElementVNode("button", {
                      onClick: handleClose,
                      class: "flex-1 px-6 py-3 bg-primary-100 text-primary-700 font-medium rounded-xl hover:bg-primary-200 transition-colors"
                    }, " I'll explore on my own ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})